import React from 'react';
import { BrowserRouter as Router, Route, Link, Switch } from "react-router-dom";
import './App.css';
import Counter from './components/Counter';
import CounterHook from './components/CounterHook';
import DevStatus from './components/DevStatus';

function App() {
  return (
    <Router>
      <div className="App">
        <nav className="navbar">
          <Link to="/" className="navbar-brand">ReactHooks-Lab</Link>
          <div className="nav-links">
            <Link to="/" className="nav-link">Home</Link>
            <Link to="/dev-status" className="nav-link">Dev Status</Link>
          </div>
        </nav>

        <div className="container">
          <Switch>
            <Route exact path="/">
              <div className="card-container">
                <Counter />
                <CounterHook />
              </div>
            </Route>
            <Route path="/dev-status">
              <DevStatus />
            </Route>
          </Switch>
        </div>
      </div>
    </Router>
  );
}

export default App;
